import React, { useEffect, useState } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  UtilityText,
  HeadingText,
} from '@leagueplatform/genesis-core';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../types/forms-library.types';

export function ConfirmationModal(props: any) {
  const { onClose, selectedIndex } = props;
  const [widthVar, setWidthVar] = useState(window.innerWidth - 10);

  const closeIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.CLOSE_ICON);
  const attentionIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.ATTENTION_ICON);

  useEffect(() => {
    setWidthVar(window.innerWidth - 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndex, window.innerWidth]);

  return (
    <Modal.Root>
      <Modal.Trigger>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
              position: 'relative',
              marginBottom: '$two',
              pointerEvents: 'none',
              '@mobile': { width: widthVar, margin: '0px auto 30px auto' },
            } as GDSStyleObject
          }
        >
          <img
            src={closeIcon as string}
            alt="close the online form"
            width="15px"
            style={{ pointerEvents: 'initial' }}
          />
        </Box>
      </Modal.Trigger>
      <Modal.Content
        data-testid="confirmation-modal"
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 650, '@mobile': '100%' }}
        // onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            {' '}
            <img
              src={attentionIcon as string}
              alt="cross icon"
              width="40px"
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              Attention
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            Are you sure you want to exit this form? Your changes will not be
            saved.
          </ParagraphText>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$two $four $one $four',
                justifyContent: 'space-around',
              } as GDSStyleObject
            }
          >
            <Modal.Close>
              <UtilityText
                css={{
                  color: '#0074C9',
                  cursor: 'pointer',
                }}
              >
                No
              </UtilityText>
            </Modal.Close>
            <UtilityText
              css={{
                color: '#0074C9',
                cursor: 'pointer',
              }}
              onClick={onClose}
            >
              Yes
            </UtilityText>
          </Box>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
